import { roleTypeLabel } from "../../../components/sp-role-type/sp-role-type.exports";

export class Controller {
    constructor(){
        this.roleTypeLabel = roleTypeLabel();
    }

    $onInit() {
        this.accountRole = roleTypeLabel(this.currentCompany.authoritiesConstants);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/roles-help/roles-help.controller.js